import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinCompletedSubHeaderComponent } from './checkin-completed-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CheckinCompletedSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [CheckinCompletedSubHeaderComponent],
})
export class CheckinCompletedSubHeaderModule {}
